var __defProp = Object.defineProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
__export(exports, {
  LoggerClass: () => LoggerClass,
  LoggerMethod: () => LoggerMethod
});
const STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/gm;
const ARGUMENT_NAMES = /([^\s,]+)/g;
function getParamNames(func) {
  const fnStr = func.toString().replace(STRIP_COMMENTS, "");
  let result = fnStr.slice(fnStr.indexOf("(") + 1, fnStr.indexOf(")")).match(ARGUMENT_NAMES);
  if (result === null)
    result = [];
  return result;
}
function LoggerMethod(level) {
  return (methodName, descriptor) => {
    const method = descriptor.value;
    descriptor.value = function(...args) {
      var _a;
      const argsName = getParamNames(method);
      const objectLog = {
        method: methodName,
        args: {}
      };
      for (const index in args) {
        const tagArg = `${methodName}-${argsName[index]}`;
        objectLog.args[tagArg] = JSON.stringify(args[index]);
      }
      (_a = this.logger) == null ? void 0 : _a.log(level, objectLog);
      const response = method.apply(this, args);
      return response;
    };
    return descriptor;
  };
}
function LoggerClass(options) {
  const level = (options == null ? void 0 : options.level) ? options.level : "debug";
  return function(target) {
    if (!(options == null ? void 0 : options.environments) || options.environments.includes(process.env.STAGE)) {
      for (const key of Reflect.ownKeys(target.prototype)) {
        if (!(options == null ? void 0 : options.blacklist) || !options.blacklist.includes(key)) {
          let descriptor = Reflect.getOwnPropertyDescriptor(target.prototype, key);
          if (descriptor) {
            descriptor = LoggerMethod(level)(key, descriptor);
            Reflect.defineProperty(target.prototype, key, descriptor);
          }
        }
      }
    }
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  LoggerClass,
  LoggerMethod
});
